import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BrandColors } from '../../constants';
import { TemplateLayout } from '../../store/interfaces';
import { isJourneyTheme } from '../utils/fallbackCondition';

interface StyleProps {
  layoutCode: TemplateLayout;
}
export const ResponseReuseMessagePageStyles = makeStyles<StyleProps>()((theme: Theme, props) => {
  return {
    innerBox: {
      borderRadius: '2px',
      border: `solid 1px ${BrandColors.grey77}`,
      backgroundColor: BrandColors.grey95,
      marginBottom: '2rem',
    },
    outerBox: {
      padding: '1.5rem',
      [theme.breakpoints.up('sm')]: {
        padding: isJourneyTheme(props.layoutCode) ? '1.5rem' : '4rem 10rem',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '2rem',
      },
    },
    pos: {
      marginTop: '1.5rem',
    },
  };
});
